import type { ComponentProps } from 'react'

/** Generated from Penpot `icons / pencil`. Do not edit by hand. */
export function PencilIcon(props: ComponentProps<'svg'>) {
  return (
    <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" {...props}>
      <path d="M12.06,0C11.74,0,11.42,0.13,11.16,0.37L9.38,2.16L13.84,6.63L15.62,4.86C16.13,4.35,16.13,3.54,15.62,3.06L12.96,0.37C12.7,0.13,12.38,0,12.06,0M8.78,2.75L1.97,9.58L4.12,9.82L4.27,11.75L6.19,11.89L6.44,14.05L13.25,7.22M1.47,10.37L0,16L5.64,14.49L5.43,12.67L3.49,12.53L3.34,10.58" />
    </svg>
  )
}
